import request from "@/axios";

/** 分页接口 */
export const getActiveList = params => {
  return request({
    url: "/lebo-member/web/member/doudian/cdkeyList/page",
    method: "get",
    params
  });
};

/** 导出财务报表订单接口 */
export const exportFinanceOrder = params => {
  return request({
    url: "/lebo-member/web/member/doudian/cdkeyList/exportOrderExcel",
    method: "get",
    params,
    responseType: "blob"
  });
};
